import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles, PROFILER_IMAGES } from '../../Common/constants';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { getQuestionConfig } from '../../config/questionsConfig';
import { NEXTGEN } from '../../config/Profiler_enum';

const questionConfig = getQuestionConfig(ProfilerQuestionID.NEXT_GEN);

const NextGen = ({
  questionId = ProfilerQuestionID.NEXT_GEN,
  title = questionConfig?.subtitle,
  subtitle = questionConfig?.question,
  value,
  defaultValue = '',
  onChange,
  onSubmit,
}) => {
  const isControlled = typeof value !== 'undefined';
  const [internalValue, setInternalValue] = useState(defaultValue);
  const selectedValue = isControlled ? value : internalValue;

  const handleSelect = (optionValue) => {
    if (!isControlled) {
      setInternalValue(optionValue);
    }
    onChange?.(optionValue);
     onSubmit?.({
      question: [
        { id: questionId, value: optionValue }
      ]
    });
  };


  return (
    <Box sx={cardStyles()}>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'space-between' }}>
          <CardHeader
            titleBold = {true}
            title={title}
            alignItems='center'
          />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, }}>
            
            <Box
              component='img'
              alt='Next generation'
              width={136}
              height={136}
              src={PROFILER_IMAGES.nextGen}
              sx={{ alignSelf: 'center' }}
            />
            <Typography variant='p3' align='center'>
              {subtitle}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {NEXTGEN.map((option) => (
              <CustomButton
                key={option.value.toString()}
                label={option.label}
                onClick={() => handleSelect(option.value)}
                size='small'
                sx={{ width: '100%'}}
                variant={option.value === true ? 'contained' : 'text'}
              />
            ))}
          </Box>
      </Box>
    </Box>
  );
};

export default NextGen;
